<template>
  <span v-if="savedPercent" class='opc-price-save-count' :class="{
    'opc-price-save-count__disabled': disabled
  }">{{ $t('billing.common.save_count', [savedPercent]) }}</span>
</template>

<script>
export default {
  name: 'SaveCount',
  props: {
    annualPrice: {
      type: Number,
      require: true
    },
    monthlyPrice: {
      type: Number,
      require: true,
    },
    savedPercentValue: {
      type: String,
    },
    disabled: Boolean,
  },
  computed: {
    savedPercent() {
      if (this.savedPercentValue) return this.savedPercentValue;

      if (this.monthlyPrice && this.annualPrice) {
        const yearTotalPricePayByMonth = this.monthlyPrice * 12;
        let result = (yearTotalPricePayByMonth - this.annualPrice) / yearTotalPricePayByMonth;
        const percent = Math.floor(result * 100);
        // if <= 0, no need to show this
        if (percent <= 0) {
          return null;
        }
        return  percent + '%';
      }
      return null;
    }
  }
};
</script>

<style lang='scss'>
.opc-price-save-count {
  font-family: 'SF Pro', 'Almaden Sans';
  text-align: center;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFF;
  background: linear-gradient(96.59deg,#084845 10.36%,#09a639 89.64%);
  white-space: nowrap;

  &__disabled {
    background: #787878 !important;
  }
}
</style>
